<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (callRetentionPolicy of callRetentionPolicies | async; track trackBy(callRetentionPolicy)) {
      <lcs-option [value]="callRetentionPolicy" id="lcs-option-id-{{ callRetentionPolicy.callRetentionPolicy }}">
         {{ callRetentionPolicy.callRetentionPolicy | callRetentionPolicyFormat }}
      </lcs-option>
      }
   </div>
</ng-template>
